module.exports = __webpack_public_path__ + "img/ic-attachment-white.02ff2d33.svg";